import * as Y from "yjs";
import { useBoard } from "../BoardContext";
import { useDeepVersion } from "../hooks";
import { useLabels } from "../labels";

const EMPTY = new Y.Map<unknown>();

/** Label chips and reaction pills rendered at the bottom of a card. */
export function CardChips({
  labelIds,
  reactions,
  cardId,
}: {
  labelIds: string[];
  reactions: Y.Map<unknown> | undefined;
  cardId: string;
}) {
  const labels = useLabels((s) => s.labels);
  const { user, canEdit } = useBoard();
  // Hooks must run unconditionally: fall back to a static empty map when the card has no reactions yet.
  const v = useDeepVersion(reactions ?? EMPTY);
  const groups = new Map<string, string[]>();
  reactions?.forEach((_, key) => {
    const [emoji, uid] = key.split("|");
    if (emoji && uid) groups.set(emoji, [...(groups.get(emoji) ?? []), uid]);
  });
  const chips = labelIds.map((id) => labels.find((l) => l.id === id)).filter(Boolean);
  if (chips.length === 0 && groups.size === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-1 px-2 pb-2" data-v={v}>
      {chips.map((l) => (
        <span
          key={l!.id}
          className="flex items-center gap-1 rounded-full bg-black/30 px-1.5 py-0.5 text-[10px]"
        >
          <span className="size-2 rounded-full" style={{ background: l!.color }} />
          {l!.name}
        </span>
      ))}
      {[...groups.entries()].map(([emoji, users]) => (
        <button
          key={emoji}
          type="button"
          onPointerDown={(e) => e.stopPropagation()}
          onClick={() =>
            canEdit &&
            window.dispatchEvent(new CustomEvent("mn:toggle-reaction", { detail: { id: cardId, emoji } }))
          }
          className={`rounded-full px-1.5 py-0.5 text-[11px] ${users.includes(user.id) ? "bg-[#8aa9ff]/30" : "bg-black/30"}`}
          title={`${users.length}`}
        >
          {emoji} {users.length}
        </button>
      ))}
    </div>
  );
}
